/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./battleRecord.vue?vue&type=template&id=713012d8&scoped=true"
import script from "./battleRecord.vue?vue&type=script&lang=js"
export * from "./battleRecord.vue?vue&type=script&lang=js"
import style0 from "./battleRecord.vue?vue&type=style&index=0&id=713012d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713012d8",
  null
  
)

export default component.exports